export { Tablet as default } from './Tablet';
